// extracted by mini-css-extract-plugin
module.exports = {"role":"JrSBQVVMe110LuQ7sKlq","more":"DoraZr8UIy4gC7IXsAd3","userEmail":"AADokMYK9X8DK1Xsbl1Q","chip":"fWFqRdWsIWTyS06ytlRi"};